import { render, staticRenderFns } from "./GroupFields.vue?vue&type=template&id=2073b0ec&scoped=true"
import script from "./GroupFields.vue?vue&type=script&lang=js"
export * from "./GroupFields.vue?vue&type=script&lang=js"
import style0 from "./GroupFields.vue?vue&type=style&index=0&id=2073b0ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2073b0ec",
  null
  
)

export default component.exports